import feeGroup from '@/api/fee-group'
import feeSetupAPI from '@/api/fee-setup'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  feeSetups: []
}

export const getters = {
  feeSetupListExcludeSelected: state => ({ addRowFee, selectedFee }) => {
    if (addRowFee != undefined && selectedFee != undefined) {
      return state.feeSetups.filter(
        p =>
          !_.includes(
            addRowFee
              .filter(ap => ap.fee_setup_id != selectedFee)
              .map(s => s.fee_setup_id),
            p.fee_setup_id
          )
      )
    }
    return state.feeSetups
  }
}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_FEE_SETUP(state, data) {
    state.feeSetups = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return feeGroup.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return feeGroup.store(data)
  },

  update(context, data) {
    return feeGroup.update(data)
  },

  destroy(context, id) {
    return feeGroup.destroy(id)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await feeGroup.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  async getFeeSetup(context) {
    if (!context.state.feeSetups.length > 0) {
      let response = await feeSetupAPI.get({
        params: {
          page: -1,
          chunk: 100,
          filter: {
            fee_type_id: 1
          },
          fields: {
            setup_payment_fee_setups: 'fee_setup_id,fee_name_en,fee_amount'
          }
        }
      })

      context.commit('SET_FEE_SETUP', response.data)

      return response
    }
  }
}
